import React from 'react'

export default ({label, payload}) =>
  <div className="morris-hover morris-default-style text-center">
    <div className="morris-hover-row-label">{label}</div>
    {payload && payload.map((data,index) =>
      <div key={index} className="morris-hover-point" style={{color: data.fill}}>
        {data.name}: {data.value}
      </div>
    )}
  </div>



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/ChartTooltipContent.js